import { picDashboard } from 'assets/Icons'
import { Icon } from 'assets/index'
import { Form } from '@unform/web'
import { FileInput } from 'components/index'
import { useRef } from 'react'
import { Label } from './style'

interface ICardProps {
  title: string
  name: string
  img?: string
}

export default function ResumePictureCard(props: ICardProps) {
  const { title, name, img } = props
  const formRef = useRef<HTMLFormElement | any>(null)
  return (
    <Label {...props} htmlFor="edit colaborator pic">
      <div className="resume-card-picture-container-left">
        <img
          className="resume-card-picture-icon"
          src={Icon('cloud.svg')}
          alt="edit pic"
        />
        <span className="resume-card-span">{title}</span>
      </div>
      <div className="resume-card-picture-container-right">
        <img className="resume-card-picture-img" src={img} alt="user pic" />
      </div>
      <Form ref={formRef} onSubmit={() => console.log('submit')}>
        <FileInput
          className="resume-card-input"
          id="edit colaborator pic"
          name={name}
        />
      </Form>
    </Label>
  )
}
